export default "__VITE_ASSET__Cc3G9vV6__"